'use strict';

exports.__esModule = true;
exports.ImageBlock = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Dialog = require('material-ui/Dialog');

var _Dialog2 = _interopRequireDefault(_Dialog);

var _Button = require('material-ui/Button');

var _Button2 = _interopRequireDefault(_Button);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
} // import './styles/styles.less';


var propTypes = {};
var defaultProps = {
  open: false
};

var styles = function styles(theme) {
  return {
    root: {},
    dialog: {
      '& .dialog-paper': {
        maxWidth: '90%',
        width: 'auto'
      }
    },
    dialogContent: {},
    thumb: {},
    img: {
      maxWidth: "100%",
      ".editor-image__wrapper &": {
        "&.thumb": {
          maxWidth: 400,
          maxHeight: 250,
          cursor: "pointer"
        }
      },
      "&.opened": {
        display: "block",
        maxWidth: "100%"
      }
    }
  };
};

var ImageBlock = exports.ImageBlock = function (_React$Component) {
  _inherits(ImageBlock, _React$Component);

  function ImageBlock(props) {
    _classCallCheck(this, ImageBlock);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleOpen = function () {
      _this.setState({
        open: true
      });
    };

    _this.handleClose = function () {
      _this.setState({
        open: false
      });
    };

    _this.state = {
      original_url: props.block.data.get("original_url"),
      src: props.block.data.get("url"),
      open: props.open
    };
    return _this;
  }

  ImageBlock.prototype.render = function render() {
    if (!this.state.src) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: ["editor-image__wrapper", classes.root].join(" ")
    }, _react2.default.createElement('div', {
      className: 'editor-image__anchore_wrapper'
    }, this.state.original_url ? _react2.default.createElement('a', {
      href: this.state.original_url,
      target: '_blank',
      rel: 'nofollow'
    }, this.state.original_url) : null), _react2.default.createElement('img', {
      className: ["thumb", classes.img, classes.thumb].join(" "),
      src: this.state.src,
      onClick: this.handleOpen
    }), _react2.default.createElement(_Dialog2.default, {
      className: [classes.dialog].join(" "),
      onBackdropClick: this.handleClose,
      onClose: this.handleClose,
      onEscapeKeyDown: this.handleClose,
      open: this.state.open,
      PaperProps: {
        className: "dialog-paper"
      }
    }, _react2.default.createElement(_Dialog.DialogContent, {
      className: [classes.dialogContent].join(" ")
    }, _react2.default.createElement('img', {
      className: ["opened", classes.img].join(" "),
      src: this.state.src
    })), _react2.default.createElement(_Dialog.DialogActions, null, _react2.default.createElement(_Button2.default, {
      key: 'close',
      onClick: this.handleClose
    }, "\u0417\u0430\u043A\u0440\u044B\u0442\u044C"))));
  };

  return ImageBlock;
}(_react2.default.Component);

ImageBlock.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};
ImageBlock.defaultProps = defaultProps;
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(ImageBlock, props);
});